import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CandidateService } from 'src/app/_services/candidate.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PipelineFilterStoreService } from '../services/pipeline-filter-store.service';
import { GlobalService } from 'src/app/_services/global.service';
import cjson from 'compressed-json';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectModule } from 'primeng/multiselect';
import { CustomChipComponent } from 'src/app/custom-chip/custom-chip.component';
import * as _ from "underscore";
import { HireSearchService } from 'src/app/hire-person-search/services/hire-search.service';
import { PipelineFilterConstants } from '../constant/pipelinefilterConstants';


@Component({
  selector: 'app-pipeline-filter',
  imports: [MatAutocompleteModule, ReactiveFormsModule, CommonModule, MultiSelectModule],
  templateUrl: './pipeline-filter.component.html',
  styleUrl: './pipeline-filter.component.scss',
})
export class PipelineFilterComponent {
 removeFilter: any;
  locationsview:any
  locationsListOpen:any
  departmentType: any;
  candidateNameRes: any
  jobTitleRes: any;
  locationRes: any
  selectedName: any[] = [];
  selectedJobTitle: any[] = [];
  selectedLocation: any[] = [];
  isEmailChecked: boolean;
  isPhoneChecked: boolean;
  userid: any;
  filterApplied: boolean;
  timeout: any;

  locationTypeValue: any = ''
  firstNameValue: any = ''
  departmentTypeValue: any = ''
  talentpoolnumber: any;
  companylist: any
  selectedcompany: any[] = []
  taglist: any
  selectedtags: any = []
  selectedrevealcontact: any
  candidateFilterForm = new UntypedFormGroup({
    candidatename: new UntypedFormControl(null),
    currentjobtitle: new UntypedFormControl(null),
    currentlocation: new UntypedFormControl(null),
    currentcompany: new UntypedFormControl(null),
    tags: new UntypedFormControl(null),
    revealdata: new UntypedFormControl('All'),
    contactRequestControl: new UntypedFormControl([]),
    contactStatusControl: new UntypedFormControl(),
    candidateSourceControl: new UntypedFormControl(),
    currentstage: new UntypedFormControl(null)

  })
  showCandidateNameLoader: boolean=false;
  showJobtitleLoader: boolean=false;
  showLocationLoader: boolean=false;
  showCompanyLoader: boolean=false;
  showTagLoader: boolean=false;
  currentPayload: any = {}; // latest payload computed by filter() - what Apply will push to the listing
filteredStageList: any;
  filterNames = PipelineFilterConstants.FILTER_NAMES;
  @Input() searchCandidates: any[] = [];


  constructor(private renderer: Renderer2,
    public _candidateservice: CandidateService, private localstorageservice:LocalStorageService,
    private activeModal: NgbActiveModal, private pipelineFilterStore: PipelineFilterStoreService, private router: Router, private route: ActivatedRoute, private hireSearchService: HireSearchService){
    this.renderer.listen('window', 'click', (e: Event) => {

      if (this.locationsview && e.target !== this.locationsview.nativeElement) {
        this.locationsListOpen = false;
      }

    });
   }
   @Output() filterEvent: EventEmitter<{}>= new EventEmitter<Event>();
   @Input() events: Observable<void>;

  multiSelectOptions: string[] = ['Webbtree Verified', 'Webbtree Introduction'];
  selectedContactRequest: string[] = [];
  contactStatusFilterOptions: {key: string, value: string}[] = [
    {key: 'Personal Email Available', value: 'personal_email'},
    {key: 'Professional Email Available', value: 'professional_email'},
    {key: 'Contact Number Available', value: 'contact_number'},
    {key: 'Contact Revealed – Not Found', value: 'contact_revealed_not_found'},
    {key: 'Contact Not Revealed', value: 'contact_not_revealed'}
  ];

  selectedStatus: any[] = [];
  contactStatusData: any = {};
  candidateSource: {key: string, value: string}[]  = [
    {key: 'Search', value: 'SEARCH'},
    {key: 'Recommended Matches', value: 'WEBBTREE_RECOMMENDATION'},
    {key: 'Inbound Applications', value: 'INBOUND'},
    {key: 'Upload Candidates', value: 'UPLOAD'}
  ];
  selectedSource: any[] = [];
  pipelineCandidateSource: string[] = [];
  projectNumber: string;
  stageList: any;
selectedStage: any[] = [];
selectedPipelineSource: any[] = [];
pipelineSourceData: any = {};

  ngOnInit() {
        this.projectNumber = window.location.pathname?.split('/')[2];

    this.getUserDetails()
    this.restoreState();
    if(this.router.url.includes('pipeline')) {
       this.getProjectpipelineListing();
     }
  }

  // The modal creates a brand new PipelineFilterComponent instance every time
  // it's opened, so all local selection state would normally be lost. Pull
  // back whatever was saved from the last time this modal was open.
  private restoreState() {
    const saved = this.pipelineFilterStore.getState();
    if (!saved) return;

    this.selectedName = saved.selectedName || [];
    this.selectedJobTitle = saved.selectedJobTitle || [];
    this.selectedLocation = saved.selectedLocation || [];
    this.isEmailChecked = saved.isEmailChecked || false;
    this.isPhoneChecked = saved.isPhoneChecked || false;
    this.selectedcompany = saved.selectedcompany || [];
    this.selectedtags = saved.selectedtags || [];
    this.selectedrevealcontact = saved.selectedrevealcontact || 'All';
    this.candidateFilterForm.patchValue({ revealdata: this.selectedrevealcontact });
    this.selectedContactRequest = saved.selectedContactRequest || [];
    this.selectedStatus = saved.selectedStatus || [];
    this.contactStatusData = saved.contactStatusData || {};
    this.currentPayload = saved.currentPayload || {};
    this.selectedSource = saved.selectedSource || [];
    this.selectedStage = saved.selectedStage || [];
  }

  // Snapshot of everything the person has picked so far, saved to the shared
  // store on every change so it survives the modal being closed and reopened.
  private persistState() {
    this.pipelineFilterStore.setState({
      selectedName: this.selectedName,
      selectedJobTitle: this.selectedJobTitle,
      selectedLocation: this.selectedLocation,
      isEmailChecked: this.isEmailChecked,
      isPhoneChecked: this.isPhoneChecked,
      selectedcompany: this.selectedcompany,
      selectedtags: this.selectedtags,
      selectedrevealcontact: this.selectedrevealcontact,
      selectedContactRequest: this.selectedContactRequest,
      selectedStatus: this.selectedStatus,
      contactStatusData: this.contactStatusData,
      currentPayload: this.currentPayload,
      selectedSource: this.selectedSource,
      selectedStage: this.selectedStage
    });
  }

  filterSlider_close() {
    document.getElementById("mySidebar_filter").style.display = "none";
    document.getElementById("myOverlay_filter").style.display = "none";
  }

  // Cancel button - close the modal without pushing anything to the listing.
  // Whatever was selected is still saved via persistState(), so reopening
  // the modal later picks up right where it was left off.
  dismiss() {
    this.activeModal.dismiss();
  }

  // Apply button - this is the single point where the listing actually
  // gets the new filter. Everything selected up to now is already reflected
  // in currentPayload (kept up to date by filter()).
  applyFilter() {
    this.pipelineFilterStore.setFilter(this.currentPayload);
     const localKey = GlobalService.hash(JSON.stringify(cjson.compress(this.currentPayload)));
        localStorage.setItem(localKey, JSON.stringify(cjson.compress(this.currentPayload)));
    this.activeModal.close();
     this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          key: encodeURIComponent(localKey)
        },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
  }

  resetFilter(type?){
    this.selectedLocation = []
    this.selectedName = []
    this.selectedJobTitle = []
    this.isEmailChecked = false
    this.isPhoneChecked = false
    this.locationTypeValue = ''
    this.firstNameValue = ''
    this.departmentTypeValue = ''
    this.selectedcompany = []
    this.selectedtags = []
    this.selectedrevealcontact = 'All';
    this.candidateFilterForm.patchValue({revealdata: 'All'})
    this.selectedContactRequest = []
    this.selectedStatus = []
     this.contactStatusData = {};
     this.selectedSource = []
     this.selectedStage = []


    if(type){
      this.filter(true)
    } else {
      this.currentPayload = { filtercount: 0 };
      this.persistState();
    }



  }

  onKeyPress(element, event){
    this.filterApplied = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.filterTypeaheads(element, event);
    },500);
  }



  filterTypeaheads(element, event){
    let data = {};
    let inputText = event.target.value;
    if(this.talentpoolnumber){
      data['talentpoolnumber'] =  this.talentpoolnumber
     }
    if(element == 'fullname'){
      data['candidatenamepayload'] = inputText,
      data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
      data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getCandidateNameTypeahead(data).subscribe((res : any) => {
          this.candidateNameRes = res;
        });
      }
    }else if(element == 'jobtitle'){
      data['selectedcandidates'] = this.selectedName ? this.selectedName.map(x => ({
        firstname : x.firstname,
        lastname: x.lastname
      })) : '';
      data['jobtitles'] = inputText
      data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getjobListTypeahead(data).subscribe((res : any) => {
          this.jobTitleRes = res;
        });
      }
    }else if(element == 'location'){
      data['selectedcandidates'] = this.selectedName ? this.selectedName.map(x => ({
        firstname : x.firstname,
        lastname: x.lastname
      })) : '';
      data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
      data['locations'] = inputText
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getLocationTypeahead(data).subscribe((res : any) => {
          this.locationRes = res;
        });
      }
    }
  }

  filter(isReset = null){
    let payload = {}
    payload['filtercount'] = 0
    if(this.selectedLocation && this.selectedLocation.length > 0){
      payload['selectedlocations'] = this.selectedLocation.map(x => x.locationname)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedName && this.selectedName.length > 0){
      payload['selectedcandidates'] = this.selectedName.map(x => ({
        firstname : x.firstname,
        middlename: x.middlename,
        lastname: x.lastname
      }))
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedJobTitle && this.selectedJobTitle.length > 0){
      payload['selectedjobtitles'] = this.selectedJobTitle.map(x => x.jobtitle)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedcompany && this.selectedcompany.length > 0) {
      payload['selectedcompanynames'] = this.selectedcompany.map(x=>x.companyname)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedtags && this.selectedtags.length > 0) {
      payload['selectedtags'] = this.selectedtags.map(x=>x.tagid)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedrevealcontact &&  this.selectedrevealcontact != 'All'){
      payload['selectedrevealcontact'] = this.selectedrevealcontact
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.isPhoneChecked){
      payload['isphoneavailable'] =  this.isPhoneChecked ? true : false
    }
    if(this.selectedContactRequest && this.selectedContactRequest.length){
      payload['selectedcontactrequested'] = this.selectedContactRequest
      payload['filtercount'] = payload['filtercount'] + 1

    }
    if(this.selectedStatus && this.selectedStatus.length){
      payload['contactavailabilitystatus'] = this.contactStatusData
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedSource && this.selectedSource.length){
      payload['candidatesource'] = this.pipelineSourceData
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedStage && this.selectedStage.length){
      payload['pipelinestages'] = this.selectedStage
      payload['filtercount'] = payload['filtercount'] + 1
    }
    let data = {
      payload: payload,
      isReset: isReset
    }
    this.currentPayload = payload; // remember it - Apply will push this to the listing
    this.persistState(); // keep the modal's state around for next time it's opened
    this.filterEvent.emit(data);
  }



  selectTypeahead(element, data){
    if(element == 'fullname'){
      let filteredName = this.selectedName.filter(x => x.candidateid == data.candidateid)
      if(filteredName && filteredName.length == 0){
        this.selectedName.push(data);
      }
    }else if(element == 'jobtitle'){
      let filteredJobtitle = this.selectedJobTitle.filter(x => x.jobtitle == data.jobtitle)
      if(filteredJobtitle && filteredJobtitle.length == 0){
        this.selectedJobTitle.push(data);
      }
    }else if(element == 'location'){
      let filteredLocation = this.selectedLocation.filter(x => x.locationname == data.locationname)
      if(filteredLocation && filteredLocation.length == 0){
        this.selectedLocation.push(data);
      }
    }
    this.filter()
  }


  unselect(data, element){
    console.log(data, 'data for unsleect')
    if(element == 'candidate'){
      this.selectedName = this.selectedName.filter(x => x.candidateid != data.candidateid)
    }else if(element == 'jobtitle'){
      this.selectedJobTitle = this.selectedJobTitle.filter(x => x.jobtitle != data.jobtitle)
    } else if(element == 'location'){
      this.selectedLocation = this.selectedLocation.filter(x => x.locationname != data.locationname)
    } else if(element == 'company'){
      this.selectedcompany = this.selectedcompany.filter(x => x.companyname != data.companyname)
    } else if(element == 'tags'){
      this.selectedtags = this.selectedtags.filter(x => x.tagtext != data.tagtext)
    }else if(element == 'selectedContactRequest'){

      this.selectedContactRequest = this.selectedContactRequest.filter(x  => x != data);
      this.candidateFilterForm.patchValue({
        contactRequestControl: this.selectedContactRequest
      }) // saved in array
    } else if(element == 'contactstatus') {
       const idx = this.selectedStatus.findIndex(s => s.value === data.value);
    if (idx > -1) {
      this.selectedStatus.splice(idx, 1);
    }

    // rebuild payload after removal
    const statusPayload: any = {};
    this.contactStatusFilterOptions.forEach(opt => {
      statusPayload[opt.value] = this.selectedStatus.some(s => s.value === opt.value);
    });
    this.contactStatusData = statusPayload;
    this.candidateFilterForm.patchValue({
      contactStatusControl: this.selectedStatus
    })
    } else if(element == 'source') {
     const idx = this.selectedSource.findIndex(s => s.value === data.value);
    if (idx > -1) {
      this.selectedSource.splice(idx, 1);
    }

    // rebuild payload after removal
    this.pipelineSourceData = _.pluck(this.selectedSource, 'value');
    this.candidateFilterForm.patchValue({
      candidateSourceControl: this.selectedSource
    })
    } else if(element == 'stage') {
      this.selectedStage = this.selectedStage.filter(x => x != data)
      this.candidateFilterForm.patchValue({
        currentstage: this.selectedStage
      })
    }

    this.filter()
  }

  checkEmail(event){
    if(event.target.checked == true){
      this.isEmailChecked = true
    }else{
      this.isEmailChecked = false
    }
    this.filter()
  }

  checkPhone(event){
    if(event.target.checked == true){
      this.isPhoneChecked = true
    }else{
      this.isPhoneChecked = false
    }
    this.filter()
  }

  getUserDetails(){
    this.userid = this.localstorageservice.getItem('userid')
  }

  getTypeaheads(type, event) {
    let data = {}
    let value = event
    if(this.talentpoolnumber){
      data['talentpoolnumber'] =  this.talentpoolnumber
     }
    data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
    data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
    data['iscontactrevealed'] = this.candidateFilterForm.getRawValue().revealdata
    data['selectedtags'] = this.selectedtags ? this.selectedtags.map(x=>x.tagtext): ''
    data['selectedcompanynames'] = this.selectedcompany ? this.selectedcompany.map(x=>x.companyname): ''
    data['selectedcandidates'] = this.selectedName?.length > 0 ? this.selectedName.map(x => ({
      firstname : x.firstname,
      middlename: x.middlename,
      lastname: x.lastname
    })) : [];
    data['searchedcandidates'] = this.searchCandidates?.length > 0 ? this.searchCandidates.map(x => ({
      firstname : x.firstname,
      middlename: x.middlename,
      lastname: x.lastname
    })) : [];
if(this.selectedName?.length > 0) {
  delete data['searchedcandidates']
}
    if(this.selectedStatus && this.selectedStatus.length){
    data['contactavailabilitystatus'] = this.contactStatusData;
    }
    if(type == 'candidatename') {
      data['candidatenamepayload'] = value,
      this.showCandidateNameLoader= true;
      data['projectnumber'] = this.projectNumber
      this._candidateservice.getCandidateNameTypeahead(data).subscribe((res : any) => {
        this.candidateNameRes = res;
        this.showCandidateNameLoader=false
      });
    } else if(type == 'jobtitle') {
      data['jobtitles'] = value
      this.showJobtitleLoader= true;
      data['projectnumber'] = this.projectNumber
      this._candidateservice.getjobListTypeahead(data).subscribe((res : any) => {
        this.jobTitleRes = res;
      this.showJobtitleLoader= false

      });
    } else if(type == 'location') {
      data['locations'] = value
      this.showLocationLoader= true;
      data['projectnumber'] = this.projectNumber
      this._candidateservice.getLocationTypeahead(data).subscribe((res : any) => {
        this.locationRes = res;
      this.showLocationLoader= false
      });
    } else if(type == 'company') {
        data['companynames'] = value
        this.showCompanyLoader= true;
        data['projectnumber'] = this.projectNumber
      this._candidateservice.getCompanyTypeahead(data).subscribe((res:any)=>{
        this.companylist = res
        this.showCompanyLoader= false
      })
    } else if(type == 'tags') {
      data['tags'] = value
      this.showTagLoader= true;
      data['projectnumber'] = this.projectNumber
      this._candidateservice.typeaheadTags(data).subscribe((res:any)=>{
        this.taglist = res
        this.showTagLoader= false
      })
    } else if(type == 'stage') {
      data['stagenames'] = value;
       this.filteredStageList = this.stageList.filter(c =>
      c.toLowerCase().includes(value.toLowerCase())
    );
    }
  }

  selectOption(event, type) {
    if(type == 'candidatename') {
      this.candidateFilterForm.patchValue({candidatename: null})
      const alreadySelected = this.selectedName.some(x => x.candidateid == event.candidateid);
      if (!alreadySelected) {
        this.selectedName.push(event);
      }
    } else if(type == 'jobtitle') {
      this.candidateFilterForm.patchValue({currentjobtitle: null})
      const alreadySelected = this.selectedJobTitle.some(x => x.jobtitle == event.jobtitle);
      if (!alreadySelected) {
        this.selectedJobTitle.push(event);
      }
    } else if(type == 'location') {
      this.candidateFilterForm.patchValue({currentlocation: null})
      const alreadySelected = this.selectedLocation.some(x => x.locationname == event.locationname);
      if (!alreadySelected) {
        this.selectedLocation.push(event)
      }
    } else if(type == 'company') {
      this.candidateFilterForm.patchValue({currentcompany: null})
      const alreadySelected = this.selectedcompany.some(x => x.companyname == event.companyname);
      if (!alreadySelected) {
        this.selectedcompany.push(event)
      }
    } else if(type == 'tags') {
      this.candidateFilterForm.patchValue({tags: null})
      const alreadySelected = this.selectedtags.some(x => x.tagtext == event.tagtext);
      if (!alreadySelected) {
        this.selectedtags.push(event)
      }
    } else if(type== 'stage') {
      this.candidateFilterForm.patchValue({currentstage: null})
      const alreadySelected = this.selectedStage.includes(event);
      if (!alreadySelected) {
        this.selectedStage.push(event)
      }
    }
    this.filter()
  }

  changereveal(event) {
    if(event.target.checked == true) {
      this.selectedrevealcontact = event.target.value
      this.candidateFilterForm.patchValue({
        revealdata: event.target.value
      })
    }
    this.filter()
  }


  toggleOption(option: any) {
      this.selectedContactRequest = option.value;

    this.filter()
  }


toggleStatus(event: any) {
  this.selectedStatus = event.value || [];   // trust PrimeNG's computed selection
  console.log(this.selectedStatus, 'selected');

  const statusPayload: any = {};
  this.contactStatusFilterOptions.forEach(opt => {
    statusPayload[opt.value] = this.selectedStatus.some(s => s.value === opt.value);
  });

  this.contactStatusData = statusPayload;
  this.filter();
}

  changePipelinedata(event, type) {
   this.selectedSource = event.value || [];   // trust PrimeNG's computed selection



  this.pipelineSourceData = _.pluck(this.selectedSource, 'value');
  this.filter();
  }

  getProjectpipelineListing() {
    this.hireSearchService.getPipelineStage(this.projectNumber).subscribe((res:any)=>{
      if(res.success == true) {
        this.stageList = res.data;
        this.filteredStageList = res.data;
      }
    })
  }

    /**
   * Method to get the accesible filter
   * @param filter
   * @returns boolean indicating whether the filter should be shown
   */
  shouldShowFilter(filter: string) {
    return this.pipelineFilterStore.shouldShowPipelineFilter(filter);
  }
}
